<template>
  <section :id class="container my-spacing-lg">
    <div class="tib-grid" :class="{ 'is-flipped': options.isFlipped }">
      <div class="grid-area-l">
        <BlokkliField
          name="field_paragraphs"
          :list="filterNullArray(paragraphs)"
          :should-render-item
          :class="{ 'count is-after': options.isNumbered }"
        />
      </div>
      <div class="mt-4 grid-area-r tablet:mt-0">
        <BlokkliField
          name="field_paragraph_media"
          :list="paragraphMedia"
          :should-render-item
          class="tib-right aspect-4/3"
        />
        <BlokkliField
          name="field_paragraphs_box"
          :list="filterNullArray(paragraphsBox)"
          :should-render-item
          non-empty-class="p-6 pr-0 max-w-[310px] desktop:max-w-[525px] bg-background ml-auto -mt-[4rem] desktop:-mt-[7.25rem] relative"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { ParagraphTextImageBoxFragment } from '#graphql-operations'
import { filterNullArray } from '~/helpers'

defineProps<ParagraphTextImageBoxFragment>()

const { options, index, siblings } = defineBlokkli({
  bundle: 'text_image_box',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  options: {
    isNumbered: {
      type: 'checkbox',
      label: 'Numbered',
      default: false,
    },
    isFlipped: {
      type: 'checkbox',
      label: 'Flip Alignment',
      default: false,
    },
  },
  editor: {
    disableEdit: true,
  },
  propsFieldMapping: {
    paragraphs: { type: 'field', name: 'field_paragraphs' },
    paragraphMedia: { type: 'field', name: 'field_paragraph_media' },
    paragraphsBox: { type: 'field', name: 'field_paragraphs_box' },
  },
})

const { shouldRenderItem } = useParagraphVisiblity()
const id = useParagraphAnchorId(index, siblings)
</script>

<style lang="postcss">
.tib-grid {
  @apply tablet:border-t tablet:border-solid tablet:border-border tablet:py-size-2;
  @screen tablet {
    @apply grid gap-size-3;
    grid-template-columns: 1fr 2fr;
    grid-template-areas: 'L R';

    &.is-flipped {
      grid-template-columns: 2fr 1fr;
      grid-template-areas: 'R L';
    }
  }
}
</style>
